<style lang="scss"></style>

<!-- eslint-disable -->
<template>
  <section class="mt-1" v-if="additionalVisitor && additionalVisitor.under18">
    <div class="d-flex">
      <b-btn variant="primary" class="full-width "
        v-if="!additionalVisitor.safeguarded_at_prison"
        @click="setSafeguardingComplete()"
      >
        <span class="fas fa-exclamation-circle"></span> Complete Safeguarding
      </b-btn>
      <b-btn variant="danger" class="full-width"
        v-else
        @click="setSafeguardingAsFalse()"
      >
        <span class="fas fa-exclamation"></span> Remove Safeguarded Status
      </b-btn>

      <b-btn variant="outline-primary" class="full-width ml-1"
             @click="viewSafeguardingHistory()"
      >
        <span class="fas fa-search"></span> View Safeguarding History
      </b-btn>
    </div>

    <b-modal id="modal-safeguarding" hide-footer>
      <additional-visitor-safeguarding-form @close="closeModals()" @refresh="closeModals(true)"
        :completing_safe_guarding="!additionalVisitor.safeguarded_at_prison"></additional-visitor-safeguarding-form>
    </b-modal>

    <b-modal id="modal-safeguarding-history" size="lg" hide-footer>
      <additional-visitor-safeguarding-history @close="closeModals()" @refresh="closeModals(true)">
      </additional-visitor-safeguarding-history>
    </b-modal>
  </section>
</template>
<!-- eslint-enable -->

<script>
  import {mapState} from 'vuex';
  import AdditionalVisitorSafeguardingForm
    from '@/components/additionalVisitors/details/sections/AdditionalVisitorSafeguardingForm.vue';
  import AdditionalVisitorSafeguardingHistory
    from '@/components/additionalVisitors/details/sections/AdditionalVisitorSafeguardingHistory.vue';

  export default {
    components: {
      AdditionalVisitorSafeguardingForm,
      AdditionalVisitorSafeguardingHistory,
    },
    props: {},
    data() {
      return {
        test: '',
      };
    },
    computed: {
      ...mapState({
        prison: state => state.prison.prison,
        additionalVisitor: state => state.participants.participant,
        safeguardingStatus: state => state.participants.safeguardingStatus,
      }),
    },
    mounted() {

    },
    methods: {
      closeModals(refresh = false) {
        this.$bvModal.hide('modal-safeguarding');
        this.$bvModal.hide('modal-safeguarding-history');

        if (refresh) {
          this.$emit('close');
        }
      },
      showModal(name) {
        this.$bvModal.show(name);
      },
      viewSafeguardingHistory() {
        // get this from portal and work with vuex
        // AdditionalVisitorSafeguardingHistory
        this.showModal('modal-safeguarding-history')
      },
      setSafeguardingComplete() {
        this.showModal('modal-safeguarding');
      },
      setSafeguardingAsFalse() {
        this.showModal('modal-safeguarding');
      },
    },
  };
</script>
